<template>
    <div class="personnel-library-page">
        <!-- 页面标题 -->
        <div class="page-title">人员库管理</div>

        <!-- 表单卡片 -->
        <el-card class="form-card">
            <el-form ref="form" :model="form" label-width="100px">
                <el-row :gutter="20">
                    <!-- 左侧表单区域 -->
                    <el-col :span="12">
                        <el-form-item label="人员姓名">
                            <el-input v-model="form.name" placeholder="输入人员姓名" />
                        </el-form-item>
                        <el-form-item label="身份证">
                            <el-input v-model="form.idCard" placeholder="输入身份证号" />
                        </el-form-item>
                        <el-form-item label="证件类型">
                            <el-select v-model="form.cardType" placeholder="证件类型">
                                <el-option label="身份证" value="idCard" />
                                <el-option label="护照" value="passport" />
                                <el-option label="其他" value="other" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件号码">
                            <el-input v-model="form.cardNo" placeholder="证件号码" />
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="其他备注信息" />
                        </el-form-item>
                    </el-col>

                    <!-- 右侧图片上传区域 -->
                    <el-col :span="12">
                        <el-form-item label="人脸照片">
                            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="证件照片">
                            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeIdCardUpload">
                                <img v-if="idCardImageUrl" :src="idCardImageUrl" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 按钮区域 -->
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">确认</el-button>
                    <el-button @click="onCancel">取消</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'PersonnelLibrary',
    data() {
        return {
            form: {
                name: '',
                idCard: '',
                cardType: '',
                cardNo: '',
                remark: ''
            },
            imageUrl: '',
            idCardImageUrl: ''
        };
    },
    methods: {
        // 人脸照片上传前检查
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
                return false;
            }

            // 预览图片
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imageUrl = e.target.result;
            };
            reader.readAsDataURL(file);
            return false; // 阻止默认上传，后续可替换为真实接口
        },
        // 证件照片上传前检查
        beforeIdCardUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传证件图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传证件图片大小不能超过 2MB!');
                return false;
            }

            // 预览图片
            const reader = new FileReader();
            reader.onload = (e) => {
                this.idCardImageUrl = e.target.result;
            };
            reader.readAsDataURL(file);
            return false; // 阻止默认上传，后续可替换为真实接口
        },
        // 提交表单
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$message.success('提交成功');
                    // 这里可以调用接口保存数据
                } else {
                    this.$message.error('请完善表单信息');
                    return false;
                }
            });
        },
        // 取消操作
        onCancel() {
            this.$refs.form.resetFields();
            this.imageUrl = '';
            this.idCardImageUrl = '';
            this.$message.info('已取消操作');
        }
    }
};
</script>

<style scoped>
.page-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
}
.form-card {
    max-width: 900px;
    margin: 0 auto;
}
.avatar-uploader {
    text-align: center;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.3s;
    width: 200px;
    height: 150px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
}
.avatar {
    width: 200px;
    height: 150px;
    display: block;
    object-fit: cover;
}
</style>
